export const live = {
    namespaced: true,
    state () {
        return {
            currentSessionId: null
        }
    },
    actions: {
    },
    mutations: {
        setSessionId (state, id) {
            state.currentSessionId = id
        }
    },
    getters: {
    }
  }
  